module.exports = __webpack_public_path__ + "img/company-logo.aa67b004.svg";